import React from "react";
import { useAuth } from "react-oidc-context";
import { UserManager } from "oidc-client-ts";
import { ToolbarButton, Image } from "@fluentui/react-components";
import { useHomeStyles } from "./style/home.style";
import { getIdpConfig } from "../../config/auth0";
import Loader from "./Loader";

const DIALOG_FLAG_KEY = "xl_IsOfficeDialog";

const isOfficeDialogWindow = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("Popup") === "true") {
      return true;
    }
    if (params.get("Popup") === "false") {
      return false;
    }
    return sessionStorage.getItem(DIALOG_FLAG_KEY) === "true";
  } catch {
    return false;
  }
};

const createUserManager = () => {
  const config = getIdpConfig();
  return new UserManager({
    authority: config.authority,
    client_id: config.client_id,
    redirect_uri: config.redirect_uri,
    silent_redirect_uri: config.silent_redirect_uri,
    response_type: config.response_type,
    scope: config.scope,
    extraQueryParams: config.extraQueryParams,
    metadata: config.metadata,
    userStore: config.userStore,
    silentRequestTimeoutInSeconds: 5,
  });
};

const notifyParentIfDialog = () => {
  if (!isOfficeDialogWindow()) {
    return false;
  }
  try {
    const localStorageData = {};
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (key) {
        const value = window.localStorage.getItem(key);
        if (value) {
          localStorageData[key] = value;
        }
      }
    }
    Office.context.ui.messageParent(
      JSON.stringify({
        type: "profileSelected",
        localStorage: localStorageData,
      })
    );
    return true;
  } catch (error) {
    console.log("Error: " + error);
    return false;
  }
};

const tryReuseExistingSession = async () => {
  const userManager = createUserManager();
  try {
    let user = await userManager.getUser();
    if (user?.refresh_token && user.expired) {
      user = await userManager.signinSilent();
    }
    return Boolean(user && !user.expired);
  } catch {
    return false;
  }
};

const Home = () => {
  const styles = useHomeStyles();
  const auth = useAuth();
  const contextInfo = Office.context.diagnostics;
  const [platformType, setplatformType] = React.useState(contextInfo.platform);

  React.useEffect(() => {
    setplatformType(contextInfo.platform);
    if (contextInfo.platform !== Office.PlatformType.OfficeOnline) {
      return () => undefined;
    }

    let cancelled = false;
    const startOnlineLogin = async () => {
      const reused = await tryReuseExistingSession();
      if (cancelled) {
        return;
      }
      if (reused && notifyParentIfDialog()) {
        return;
      }
      if (cancelled) {
        return;
      }
      await auth.signinRedirect({
        prompt: "none",
        extraQueryParams: getIdpConfig().extraQueryParams,
      });
    };

    void startOnlineLogin();
    return () => {
      cancelled = true;
    };
  }, []);

  if (platformType === Office.PlatformType.OfficeOnline) {
    return <Loader label="Signing in"></Loader>;
  }

  return (
    <>
      <div className={styles.loginwrapper}>
        <div className={styles.logincontentwrapper}>
          <div title="MSCI Inc." id="custom-prompt-logoheader" className={styles.header}></div>
          <div className={styles.logo}>
            <Image alt="MSCI Inc." src="https://static-qa.msci.com/images/MSCI2019Logo.svg" />{" "}
          </div>
          <div title="MSCI Inc." id="custom-prompt-logo" className={styles.header}></div>
          <div>
            <h2 className={styles.h2}>Sign In</h2>
          </div>
          <div>
            <p className={styles.p}>
              Sign in using your <br></br>corporate credentials
            </p>
          </div>
          <div className={styles.loginDiv}>
            <ToolbarButton className={styles.loginButton} onClick={() => void auth.signinRedirect()}>
              Continue
            </ToolbarButton>
          </div>
        </div>
      </div>
    </>
  );
};
export default Home;
